import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76f75466"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex" }
const _hoisted_2 = { class: "p-fluid" }
const _hoisted_3 = {
  key: 0,
  class: "p-col-3"
}
const _hoisted_4 = {
  key: 1,
  class: "p-col-3"
}
const _hoisted_5 = {
  key: 2,
  class: "p-col-3"
}
const _hoisted_6 = {
  key: 3,
  class: "p-col-3"
}
const _hoisted_7 = {
  key: 4,
  class: "p-col-3"
}
const _hoisted_8 = {
  key: 5,
  id: "pickerField",
  class: "p-col-9"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = { key: 5 }
const _hoisted_15 = { key: 6 }
const _hoisted_16 = { key: 7 }
const _hoisted_17 = {
  key: 6,
  class: "p-col-9"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 7,
  class: "p-col-9"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 8,
  class: "p-col-9"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 9,
  class: "p-col-9"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 10,
  class: "p-col-9"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 1,
  id: "taxon-picker",
  class: "p-col-12 required"
}
const _hoisted_28 = { class: "section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_info_button = _resolveComponent("info-button")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_string_picker = _resolveComponent("string-picker")!
  const _component_number_picker = _resolveComponent("number-picker")!
  const _component_category_picker = _resolveComponent("category-picker")!
  const _component_multi_select_picker = _resolveComponent("multi-select-picker")!
  const _component_boolean_picker = _resolveComponent("boolean-picker")!
  const _component_image_picker = _resolveComponent("image-picker")!
  const _component_person_picker = _resolveComponent("person-picker")!
  const _component_specimen_picker = _resolveComponent("specimen-picker")!
  const _component_taxon_picker = _resolveComponent("taxon-picker")!
  const _component_Panel = _resolveComponent("Panel")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Panel, {
      toggleable: true,
      collapsed: _ctx.isCollapsed,
      class: "p-col-8 p-offset-2 required"
    }, {
      header: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('form.species_record') + ' ') + " " + _toDisplayString(_ctx.recordIdx + 1) + " : " + _toDisplayString(_ctx.taxonNameDict[_ctx.recordIdx]), 1)
      ]),
      icons: _withCtx(() => [
        _withDirectives(_createVNode(_component_Button, {
          class: "p-mr-1 p-button-rounded p-button-danger tooltipButton",
          icon: "pi pi-trash",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.remove($event)), ["prevent"]))
        }, null, 512), [
          [
            _directive_tooltip,
            _ctx.$t('form.removeSingleRecord'),
            void 0,
            { right: true }
          ]
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_ConfirmPopup),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.record, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "p-field p-grid",
              key: item
            }, [
              (item.type !== 'hidden' && !['substrateFine', 'woodQuality', 'woodDegradation', 'hostFungus', 'hostLichen'].includes(item.name))
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _withDirectives((_openBlock(), _createBlock(_component_Button, {
                      class: _normalizeClass(["tooltipButton formBox", { required: item.required, notRequired: !item.required, pError: _ctx.$store.state.errors['records'] === undefined ? false: _ctx.$store.state.errors['records'][_ctx.recordIdx][item.name] }]),
                      tabindex: "-1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_info_button),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(item.title)), 1)
                      ]),
                      _: 2
                    }, 1032, ["class"])), [
                      [
                        _directive_tooltip,
                        _ctx.$t(item.help),
                        void 0,
                        { right: true }
                      ]
                    ])
                  ]))
                : (item.type !== 'hidden' && _ctx.substrateCoarseWithChildCategories.includes(_ctx.storedSubstrateCoarse)  && ['substrateFine'].includes(item.name))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _withDirectives((_openBlock(), _createBlock(_component_Button, {
                        class: _normalizeClass(["tooltipButton formBox", { required: item.required, notRequired: !item.required, pError: _ctx.$store.state.errors['records'] === undefined ? false: _ctx.$store.state.errors['records'][_ctx.recordIdx][item.name] }]),
                        tabindex: "-1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_info_button),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t(item.title)), 1)
                        ]),
                        _: 2
                      }, 1032, ["class"])), [
                        [
                          _directive_tooltip,
                          _ctx.$t(item.help),
                          void 0,
                          { right: true }
                        ]
                      ])
                    ]))
                  : (item.type !== 'hidden' && _ctx.storedSubstrateCoarse === 3 && ['woodQuality', 'woodDegradation'].includes(item.name))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _withDirectives((_openBlock(), _createBlock(_component_Button, {
                          class: _normalizeClass(["tooltipButton formBox", { required: item.required, notRequired: !item.required, pError: _ctx.$store.state.errors['records'] === undefined ? false: _ctx.$store.state.errors['records'][_ctx.recordIdx][item.name] }]),
                          tabindex: "-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_info_button),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t(item.title)), 1)
                          ]),
                          _: 2
                        }, 1032, ["class"])), [
                          [
                            _directive_tooltip,
                            _ctx.$t(item.help),
                            void 0,
                            { right: true }
                          ]
                        ])
                      ]))
                    : (item.type !== 'hidden' && _ctx.storedSubstrateCoarse === 11 && ['hostLichen'].includes(item.name))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            class: _normalizeClass(["tooltipButton formBox", { required: item.required, notRequired: !item.required, pError: _ctx.$store.state.errors['records'] === undefined ? false: _ctx.$store.state.errors['records'][_ctx.recordIdx][item.name] }]),
                            tabindex: "-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_info_button),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t(item.title)), 1)
                            ]),
                            _: 2
                          }, 1032, ["class"])), [
                            [
                              _directive_tooltip,
                              _ctx.$t(item.help),
                              void 0,
                              { right: true }
                            ]
                          ])
                        ]))
                      : (item.type !== 'hidden' && _ctx.storedSubstrateCoarse === 8 && ['hostFungus'].includes(item.name))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _withDirectives((_openBlock(), _createBlock(_component_Button, {
                              class: _normalizeClass(["tooltipButton formBox", { required: item.required, notRequired: !item.required, pError: _ctx.$store.state.errors['records'] === undefined ? false: _ctx.$store.state.errors['records'][_ctx.recordIdx][item.name] }]),
                              tabindex: "-1"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_info_button),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t(item.title)), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"])), [
                              [
                                _directive_tooltip,
                                _ctx.$t(item.help),
                                void 0,
                                { right: true }
                              ]
                            ])
                          ]))
                        : _createCommentVNode("", true),
              (item.type !== 'group' && item.type !== 'hidden' && !['substrateFine', 'woodQuality', 'woodDegradation', 'hostFungus', 'hostLichen'].includes(item.name))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (item.component === _ctx.ComponentEnum.DatePicker)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                          _createVNode(_component_date_picker, {
                            name: item.name,
                            value: item.value,
                            onSelect: _ctx.select
                          }, null, 8, ["name", "value", "onSelect"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.component === _ctx.ComponentEnum.StringPicker)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                          _createVNode(_component_string_picker, {
                            class: "field",
                            onSelect: _ctx.select,
                            value: item.value,
                            name: item.name,
                            placeholder: _ctx.$t(item.placeholder)
                          }, null, 8, ["onSelect", "value", "name", "placeholder"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.component === _ctx.ComponentEnum.NumberPicker)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                          _createVNode(_component_number_picker, {
                            class: "field",
                            name: item.name,
                            value: item.value,
                            placeholder: _ctx.$t(item.placeholder),
                            onSelect: _ctx.select
                          }, null, 8, ["name", "value", "placeholder", "onSelect"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.component === _ctx.ComponentEnum.CategoryPicker)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          _createVNode(_component_category_picker, {
                            class: "field",
                            name: item.name,
                            api: item.api,
                            filter: item.filter,
                            clearable: item.clearable,
                            value: item.value == null ? item.defaultValue : item.value,
                            onSelect: _ctx.select
                          }, null, 8, ["name", "api", "filter", "clearable", "value", "onSelect"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.component === _ctx.ComponentEnum.MultiSelectPicker)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                          _createVNode(_component_multi_select_picker, {
                            class: "field",
                            name: item.name,
                            api: item.api,
                            filter: true,
                            value: item.value == null ? item.defaultValue : item.value,
                            clearable: true,
                            onSelect: _ctx.select
                          }, null, 8, ["name", "api", "value", "onSelect"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.component === _ctx.ComponentEnum.BooleanPicker)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                          _createVNode(_component_boolean_picker, {
                            class: "field",
                            name: item.name,
                            value: item.value,
                            onSelect: _ctx.select
                          }, null, 8, ["name", "value", "onSelect"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.component === _ctx.ComponentEnum.ImagePicker)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                          _createVNode(_component_image_picker, {
                            class: "field",
                            name: item.name,
                            value: item.value,
                            onSelect: _ctx.select
                          }, null, 8, ["name", "value", "onSelect"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.component === _ctx.ComponentEnum.PersonPicker)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                          _createVNode(_component_person_picker, {
                            class: "field",
                            name: item.name,
                            value: item.value,
                            onSelect: _ctx.select,
                            api: item.api
                          }, null, 8, ["name", "value", "onSelect", "api"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (item.type !== 'group' && item.type !== 'hidden' && _ctx.substrateCoarseWithChildCategories.includes(_ctx.storedSubstrateCoarse)  && ['substrateFine'].includes(item.name))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (item.component === _ctx.ComponentEnum.CategoryPicker)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                            _createVNode(_component_category_picker, {
                              class: "field",
                              name: item.name,
                              api: item.api,
                              filter: item.filter,
                              clearable: item.clearable,
                              value: item.value == null ? item.defaultValue : item.value,
                              onSelect: _ctx.select
                            }, null, 8, ["name", "api", "filter", "clearable", "value", "onSelect"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (item.type !== 'group' && item.type !== 'hidden' && _ctx.storedSubstrateCoarse === 3 && ['woodQuality', 'woodDegradation'].includes(item.name))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        (item.component === _ctx.ComponentEnum.CategoryPicker)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                              _createVNode(_component_category_picker, {
                                class: "field",
                                name: item.name,
                                api: item.api,
                                filter: item.filter,
                                clearable: item.clearable,
                                value: item.value == null ? item.defaultValue : item.value,
                                onSelect: _ctx.select
                              }, null, 8, ["name", "api", "filter", "clearable", "value", "onSelect"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (item.type !== 'group' && item.type !== 'hidden' && _ctx.storedSubstrateCoarse === 11 && ['hostLichen'].includes(item.name))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          (item.component === _ctx.ComponentEnum.CategoryPicker)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                _createVNode(_component_category_picker, {
                                  class: "field",
                                  name: item.name,
                                  api: item.api,
                                  filter: item.filter,
                                  clearable: item.clearable,
                                  value: item.value == null ? item.defaultValue : item.value,
                                  onSelect: _ctx.select
                                }, null, 8, ["name", "api", "filter", "clearable", "value", "onSelect"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (item.type !== 'group' && item.type !== 'hidden' && _ctx.storedSubstrateCoarse === 8 && ['hostFungus'].includes(item.name))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            (item.component === _ctx.ComponentEnum.CategoryPicker)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                  _createVNode(_component_category_picker, {
                                    class: "field",
                                    name: item.name,
                                    api: item.api,
                                    filter: item.filter,
                                    clearable: item.clearable,
                                    value: item.value == null ? item.defaultValue : item.value,
                                    onSelect: _ctx.select
                                  }, null, 8, ["name", "api", "filter", "clearable", "value", "onSelect"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (item.type === 'group' && item.type !== 'hidden')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              (item.component === _ctx.ComponentEnum.SpecimenPicker)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                    _createVNode(_component_specimen_picker, {
                                      class: "field",
                                      name: item.name,
                                      value: item.value,
                                      title: item.title,
                                      onSelect: _ctx.select
                                    }, null, 8, ["name", "value", "title", "onSelect"])
                                  ]))
                                : _createCommentVNode("", true),
                              (item.component === _ctx.ComponentEnum.TaxonPicker)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _createElementVNode("span", _hoisted_28, [
                                      _createVNode(_component_taxon_picker, {
                                        onSelect: _ctx.select,
                                        name: item.name,
                                        value: item.value,
                                        title: item.title,
                                        required: item.required
                                      }, null, 8, ["onSelect", "name", "value", "title", "required"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["collapsed"])
  ]))
}